"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodePostSchema = void 0;
const yup_1 = require("yup");
const CodePostSchema = (0, yup_1.object)().shape({
    caller: (0, yup_1.string)().required().min(1),
    called: (0, yup_1.string)().required().min(1),
    code: (0, yup_1.string)().required().min(1),
    category: (0, yup_1.string)().required().min(1),
    country: (0, yup_1.string)().required().min(1),
    countryCode: (0, yup_1.string)().required().min(1),
});
exports.CodePostSchema = CodePostSchema;
